import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class RestaurantItem extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'RestaurantItem';

    // Define default properties here
    static instanceDefaults() {
        return {
            html_desc: '',
            html_desc_tc: '',
            html_desc_sc: ''
        }
    }
}

const servicePath = 'f-restaurant-items';
const servicePlugin = makeServicePlugin({
    Model: RestaurantItem,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin